// The private note a holder can add to a vouch link. It lives only in the URL
// fragment (#note=...): browsers never send a fragment to a server, not in the
// request line and not in Referer. The viewer never reads it into an API call,
// a log or analytics (it has none), and renders it as text only.
export const MAX_NOTE = 200;

const clean = (s: string) => s.replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/g, "").slice(0, MAX_NOTE);

export function vouchLink(origin: string, token: string, note?: string): string {
  const base = `${origin}/v/${token}`;
  const n = clean((note ?? "").trim());
  return n ? `${base}#note=${encodeURIComponent(n)}` : base;
}

export function noteFromHash(hash: string): string {
  const m = /(?:^#|&)note=([^&]*)/.exec(hash ?? "");
  if (!m) return "";
  try { return clean(decodeURIComponent(m[1].replace(/\+/g, "%20"))); } catch { return ""; }
}
